import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';

import config from 'src/config';

const AlertContext = createContext({
  alert: null,
  hideDuration: 5000,
  setAlert: () => Promise.resolve(),
  setUnhandledError: () => Promise.resolve()
});

const { errorMessage } = config;

export const AlertProvider = (props) => {
  const { children } = props;
  const [alert, setAlert] = useState(null);
  const [hideDuration, setHideDuration] = useState(5000);

  const setUnhandledError = (message) => {
    setHideDuration(10000);
    setAlert({
      message: message || errorMessage,
      action: null
    });
  };

  return (
    <AlertContext.Provider
      value={{
        alert,
        hideDuration,
        setAlert: (a) => {
          setHideDuration(5000);
          let data = a;
          if (typeof a === 'string') {
            data = {
              message: a
            };
          }
          setAlert(data);
        },
        setUnhandledError
      }}
      {...props}
    >
      {children}
    </AlertContext.Provider>
  );
};

AlertProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default AlertContext;
